<template>
    <el-dropdown
        ref="areaDropdown"
        trigger="click"
        :hide-on-click="false"
        placement="bottom-start"
        @visible-change="checkArea"
    >
        <div
            class="flex align-center m-r-10 p-lr-20 h-52 b-r-4 cursor-point container"
        >
            <img class="area_logo" :src="logoSrc(form.area_logo)" alt="" />
            <span class="m-r-9">{{ `+${form.area_code}` }}</span>
            <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu
            ref="areaDropdownMenu"
            slot="dropdown"
            class="area_menu"
            style="margin-top: 0"
        >
            <el-dropdown-item class="p-lr-12 font-16 ff-Regular text-c1A1F2A">
                <div class="p-r-8">
                    <div class="input_item">
                        <el-input
                            ref="searchArea"
                            v-model.trim="searchText"
                            :class="{ is_focus: isFocus }"
                            :placeholder="$t('message.user.search')"
                            @input="search()"
                            @focus="isFocus = true"
                            @blur="isFocus = false"
                            @keyup.enter.native="search()"
                        >
                            <el-button slot="prepend" icon="el-icon-search" />
                        </el-input>
                        <!-- <el-button icon="el-icon-search"></el-button> -->
                    </div>
                    <div class="area_box">
                        <div
                            v-for="item in filterList"
                            :key="item.id"
                            class="area_item flex align-center"
                            @click="handleCommand(item)"
                        >
                            <img
                                class="w-22 h-22 m-r-12 b-r-p50"
                                :src="logoSrc(item.img)"
                                alt=""
                            />
                            <div class="flex justify-between w-p100 l-h-19">
                                <span>{{
                                    lang == 'zh-CN'
                                        ? item.country
                                        : item.country_en
                                }}</span>
                                <span>{{ `+${item.area_code}` }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { defaultCountry } from '@/utils/country';
import { getLanguage } from '@/utils/auth';
export default {
    props: {
        areaList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        isFilter: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const country = defaultCountry().country;
        const area_code = defaultCountry().area_code;
        const area_logo = defaultCountry().area_logo;
        return {
            searchText: '',
            isFocus: false,
            form: {
                area_logo,
                area_code,
                country
            },
            filterList: [],
            storeList: [],
            lang: ''
        };
    },
    created() {
        this.lang = getLanguage();
    },
    methods: {
        logoSrc(imageName) {
            return require(`@/assets${imageName}`);
        },
        // 选择区号
        checkArea(visible) {
            if (visible) {
                const idList = [
                    '47',
                    '31',
                    '183',
                    '61',
                    '80',
                    '79',
                    '88',
                    '93',
                    '26',
                    '59',
                    '55'
                ];
                // if (this.isFilter) {
                // const arr = this.areaList.filter(item => {
                //     return idList.includes(item.id);
                // });
                // this.filterList = JSON.parse(JSON.stringify(arr));
                // this.storeList = JSON.parse(JSON.stringify(arr));
                let arr = [];
                let deObj = null;
                this.areaList.forEach(item => {
                    if (idList.includes(item.id)) {
                        item.id == '47'
                            ? (deObj = item)
                            : arr.unshift({ ...item, _disabled: false });
                    } else {
                        arr.push({ ...item, _disabled: true });
                    }
                });
                arr.unshift({ ...deObj, _disabled: false });
                this.filterList = JSON.parse(JSON.stringify(arr));
                this.storeList = JSON.parse(JSON.stringify(arr));
                // } else {
                //     this.filterList = [...this.areaList];
                //     this.storeList = JSON.parse(JSON.stringify(this.areaList));
                // }
                this.$nextTick(() => {
                    this.searchText = '';
                    this.$refs.searchArea ? this.$refs.searchArea.focus() : '';
                });
            }
        },
        handleCommand(command) {
            // if (command._disabled) {
            //     this.$message.info(this.$t('Not_supported_yet'));
            //     return;
            // }
            this.$refs.areaDropdown.hide();
            this.selectArea(command);
        },
        // 选中当前地区或区号
        selectArea(item) {
            this.form.area_logo = item.img;
            this.form.area_code = item.area_code;
            this.form.country = item.country;
            this.$emit('updataArea', item);
        },
        // 搜索地区
        search() {
            this.filterList = [];
            if (this.lang == 'zh-CN') {
                this.filterList = this.storeList.filter(
                    item =>
                        item.country.indexOf(this.searchText) > -1 ||
                        item.area_code.indexOf(this.searchText) > -1
                );
            } else {
                this.filterList = this.storeList.filter(
                    item =>
                        item.country_en.indexOf(this.searchText) > -1 ||
                        item.area_code.indexOf(this.searchText) > -1
                );
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    border: 1px solid #bbbbbb;
    border-radius: 8px;
}
.area_logo {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    margin-right: 8px;
}
</style>
<style lang="scss">
.area_menu {
    width: 430px;
    background-color: #ffffff;
    box-shadow: 2px 4px 4px 0px rgba(44, 57, 74, 0.1);
    border: 1px solid #dfe1e5;
    margin: 0;
    .popper__arrow {
        display: none;
    }
    .el-dropdown-menu__item {
        padding: 0;
        line-height: 46px !important;
        &:hover {
            background-color: transparent;
            color: #1a1f2a;
        }
    }
    .area_box {
        width: 100%;
        max-height: 307px;
        overflow: scroll;
        overflow-x: hidden;
        padding: 0 12px;
        &::-webkit-scrollbar {
            width: 12px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 8px;
            background-color: #dfe1e5;
        }
    }
    .area_item {
        padding: 12px 28px 12px 10px;
        &:hover {
            background-color: #f6f6f6;
            color: #1a1f2a;
        }
    }
    .input_item {
        padding: 18px 24px 12px 12px;
        .el-input {
            border: 1px solid #dfe1e5;
            border-radius: 4px;
            padding: 0 12px 0 30px;
            &:hover {
                border-color: $basicColor;
            }
            &:focus {
                border-color: $basicColor;
            }
        }
        .el-input-group__prepend {
            border: none;
            padding: 0;
            .el-button {
                padding: 0;
            }
        }
        .el-input__inner {
            color: #1a1f2a !important;
            height: 33px;
            border: none;
            padding: 0;
        }
        .is_focus {
            border-color: $basicColor;
        }
    }
}
</style>
